import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { unsubscribe } from '../services/api';
import './Unsubscribe.css';

const Unsubscribe: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<boolean>(false);
  const [queryId, setQueryId] = useState<string | null>(null);
  
  const location = useLocation();
  const navigate = useNavigate();
  
  // Extract query_id from URL query parameters
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const queryIdParam = params.get('query_id');
    if (queryIdParam) {
      setQueryId(queryIdParam);
    } else {
      setError('Missing query ID. Please check the link and try again.');
    }
  }, [location]);
  
  const handleConfirmUnsubscribe = async () => {
    if (!queryId) {
      setError('Missing query ID. Please check the link and try again.');
      return;
    }
    
    setLoading(true);
    setError(null);
    
    try {
      await unsubscribe(queryId);
      setSuccess(true);
    } catch (err) {
      console.error('Error unsubscribing:', err);
      setError('An error occurred while processing your request. Please try again later.');
    } finally {
      setLoading(false);
    }
  };
  
  const handleGoToHome = () => {
    navigate('/');
  };
  
  return (
    <div className="unsubscribe-container">
      <div className="unsubscribe-content">
        <div className="unsubscribe-card">
          <header className="unsubscribe-header">
            <h1>Unsubscribe from Brief</h1>
            <p className="unsubscribe-subtitle">Manage your email preferences</p>
          </header>
          
          {error && (
            <div className="error-alert">
              <div className="error-icon">!</div>
              <div className="error-alert-message">{error}</div>
            </div>
          )}
          
          {success ? (
            <div className="unsubscribe-success">
              <div className="success-icon">✓</div>
              <h2>Successfully Unsubscribed</h2>
              <p>You have been unsubscribed from this specific brief. You will no longer receive emails for this topic.</p>
              <button 
                className="primary-button"
                onClick={handleGoToHome}
              >
                Return to Home
              </button>
            </div>
          ) : (
            <div className="unsubscribe-confirmation">
              <h2>Confirm Unsubscribe</h2>
              <p>Are you sure you want to unsubscribe from this specific brief?</p>
              <p>You won't receive any more updates for this topic.</p>
              
              <div className="button-group">
                <button 
                  className="secondary-button"
                  onClick={handleGoToHome}
                  disabled={loading}
                >
                  Cancel
                </button>
                
                <button 
                  className="primary-button"
                  onClick={handleConfirmUnsubscribe}
                  disabled={loading || !queryId}
                >
                  {loading ? (
                    <div className="loading-button-content">
                      <span className="loading-spinner"></span>
                      <span>Processing...</span>
                    </div>
                  ) : (
                    'Yes, Unsubscribe Me'
                  )}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Unsubscribe; 